import { render, staticRenderFns } from "./HsCodesOverview.vue?vue&type=template&id=79dd6140&"
import script from "./HsCodesOverview.vue?vue&type=script&lang=js&"
export * from "./HsCodesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports